import { trans } from 'laravel-vue-i18n';
import { DateTime } from 'luxon';
export default class Utils {
    /**
     * @deprecated Use exported enumToDropdownOptions function instead.
     */
    static enumToDropdownOptions(enumObject, className) {
        return enumToDropdownOptions(enumObject, className);
    }
}
export function enumToDropdownOptions(enumObject, className, parseInt = true) {
    const options = [];
    Object.keys(enumObject).forEach((key) => {
        options.push({
            label: trans('enums.' + className + '.' + key),
            value: parseInt
                ? Number.parseInt(enumObject[key])
                : enumObject[key],
        });
    });
    return options;
}
export function formatISODate(date) {
    return DateTime.fromISO(date).toFormat('dd/MM/yyyy');
}
export function formatJSDate(date) {
    return DateTime.fromJSDate(date).toFormat('dd/MM/yyyy');
}
export function getEnumKeyByValue(enumObject, value) {
    return value
        ? Object.keys(enumObject)[Object.values(enumObject).indexOf(value.toString())]
        : '';
}
export function concatPlotsCodes(plots) {
    return plots ? plots.map((plot) => plot.code).join(', ') : '';
}
export function processFormDocuments(formData, newDocuments, existingDocuments) {
    newDocuments.forEach((file) => {
        formData.append('documents[]', file);
    });
    if (existingDocuments && Array.isArray(existingDocuments)) {
        existingDocuments
            .filter((document) => document.pending_delete)
            .forEach((document) => {
            formData.append('deleted_documents[]', document.id.toString());
        });
    }
}
export function processDataForm(data, newDocuments = [], existingDocuments = []) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
        if (data[key] !== undefined) {
            formData.append(key, data[key] ?? '');
        }
    });
    formData.append('date', DateTime.fromJSDate(data.date).toISODate());
    if (data.plot_ids) {
        data.plot_ids.forEach((plot_id) => {
            formData.append('plot_ids[]', plot_id.toString());
        });
    }
    processFormDocuments(formData, newDocuments, existingDocuments);
    if (data.id) {
        formData.append('_method', 'PATCH');
    }
    return formData;
}
export function waitForComponent(component) {
    return new Promise((resolve) => {
        if (component.value !== undefined) {
            return resolve(component.value);
        }
        const observer = new MutationObserver((mutations) => {
            if (component.value !== undefined) {
                observer.disconnect();
                resolve(component.value);
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
}
export function panelTitle(panelName, extra = '') {
    let transKey = `panels.${panelName}.title`;
    return trans(transKey) + extra;
}
